import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

function NextUpCardsSkeleton() {
  return (
    <Stack
      gap={{ xs: '8px', md: '12px' }}
      height={{ xs: 200, md: 215 }}
      mb={{ xs: '16px', md: '32px' }}
    >
      <Skeleton
        height="100%"
        width="100%"
      />
    </Stack>
  );
}

export default NextUpCardsSkeleton;
